import { UserModel } from '../types/User';

function getUserFullName(user?: UserModel): string {
    if (!user) return '';
    const { firstName = '', lastName = '' } = user;
    return `${firstName} ${lastName}`.trim();
}

export { getUserFullName };
